import { Apple, Play } from "lucide-react";
import { toast } from "sonner";

const STORES = [
  {
    id: "app-store",
    icon: Apple,
    eyebrow: "Download on the",
    name: "App Store",
  },
  {
    id: "google-play",
    icon: Play,
    eyebrow: "Get it on",
    name: "Google Play",
  },
];

export const StoreButtons = ({ centered = false }) => (
  <div className={centered ? "flex flex-col items-center" : ""}>
    <div className={`flex flex-wrap gap-4 ${centered ? "justify-center" : ""}`}>
      {STORES.map((store) => (
        <button
          key={store.id}
          type="button"
          data-testid={`${store.id}-download-button`}
          onClick={() =>
            toast.info(
              `The official ${store.name} link will be added here once DELSHA launches.`,
            )
          }
          className="group flex items-center gap-3 rounded-2xl bg-slate-900 px-5 py-3 text-left text-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg"
        >
          <store.icon className="h-7 w-7 transition-transform duration-200 group-hover:scale-110" />
          <span>
            <span className="block text-[10px] uppercase tracking-wider text-slate-300">
              {store.eyebrow}
            </span>
            <span className="block font-display text-lg font-semibold leading-tight">
              {store.name}
            </span>
          </span>
        </button>
      ))}
    </div>
    <p
      data-testid="store-links-placeholder-note"
      className="mt-3 font-mono text-xs uppercase tracking-widest text-blue-600"
    >
      Official store links coming soon
    </p>
  </div>
);
